import Route from '@ember/routing/route';

export default class StripeConnectRoute extends Route {}
